const stepsConstant = {
  welcome: 0,
  selectPayment: 1,
  selectInstamment: 2,
  showQrCode: 3,
  result: 4,
};

export default stepsConstant;
